export default __webpack_public_path__ + "static/media/Darshana_Patel.b6805623.jpg";